import { Button, Col, Row, Space } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

export const FormActions = ({
    canEdit,
    onCancel,
    isLoading
}) => {
    if (!canEdit) return null;

    return (
        <Row justify="end" style={{ marginTop: 32 }}>
            <Col>
                <Space size="middle">
                    <Button
                        onClick={onCancel}
                        style={{ borderRadius: '8px' }}
                    >
                        Cancelar
                    </Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        loading={isLoading}
                        icon={<SaveOutlined />}
                    >
                        Guardar Cambios
                    </Button>
                </Space>
            </Col>
        </Row>
    );
};
